// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__oIGmL"};